import { useMemo } from "react";
import PropTypes from "prop-types";
import { Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

function TestInfoTable({ selectedDevice, testInfoData }) {
  const tableData = useMemo(() => {
    const columns = [
      { Header: "Attenuation", accessor: "attenuation" },
      { Header: "Date", accessor: "date" },
      { Header: "Device", accessor: "device" },
      { Header: "Input Voltage", accessor: "input_voltage" },
      { Header: "N", accessor: "n" },
      { Header: "Temperature", accessor: "temperature" },
      { Header: "Time", accessor: "time" },
    ];

    const rows =
      testInfoData?.map((record) => ({
        attenuation: record.Attenuation ?? record.attenuation ?? "",
        date: record.Date ?? record.date ?? "",
        device: record.Device ?? record.device ?? "",
        input_voltage: record.Input_Voltage ?? record.input_voltage ?? "",
        n: record.N ?? record.n ?? "",
        temperature: record.Temperature ?? record.temperature ?? "",
        time: record.Time ?? record.time ?? "",
      })) || [];

    return { columns, rows };
  }, [testInfoData, selectedDevice]);

  return (
    <Card>
      <MDBox
        mx={2}
        mt={-3}
        py={3}
        px={2}
        variant="gradient"
        bgColor="info"
        borderRadius="lg"
        coloredShadow="info"
      >
        <MDTypography variant="h6" color="white">
          Test Info for Device {selectedDevice}
        </MDTypography>
      </MDBox>
      <MDBox pt={3}>
        <DataTable
          table={tableData}
          isSorted={true}
          entriesPerPage={false}
          showTotalEntries={false}
          noEndBorder
        />
      </MDBox>
    </Card>
  );
}

TestInfoTable.propTypes = {
  selectedDevice: PropTypes.string.isRequired,
  testInfoData: PropTypes.arrayOf(PropTypes.object),
};

export default TestInfoTable;
